import * as React from 'react';
export const etradeSvg = React.forwardRef(function etradeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F0F5F7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_etrade__a)',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8.57 8.21a237.249 237.249 0 0 0 3.765-2.156 842.26 842.26 0 0 0 3.328 5.592c.862 1.44 1.717 2.882 2.571 4.329a429.094 429.094 0 0 1-2.598 4.373 582.91 582.91 0 0 0-3.293 5.551 289.835 289.835 0 0 0-3.77-2.094c1.092-1.927 2.27-3.808 3.373-5.729-2.25-.003-4.502-.003-6.75.004 0-1.392 0-2.781-.007-4.17h6.761c-1.133-1.895-2.282-3.787-3.38-5.7Z',
        fill: '#634EA0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M19.08 6.054c1.33.727 2.66 1.447 3.98 2.185-1.22 1.88-2.365 3.797-3.602 5.667 2.378-.003 4.759-.003 7.136-.003.028 1.385.032 2.766.028 4.148-2.385.025-4.77.014-7.156.01 1.197 1.907 2.394 3.813 3.582 5.723-1.32.694-2.642 1.4-3.967 2.097-1.177-1.844-2.325-3.703-3.514-5.54a427.85 427.85 0 0 0 2.735-4.373c-.9-1.447-1.799-2.89-2.707-4.33 1.161-1.862 2.325-3.721 3.486-5.584Z',
        fill: '#99CA3C',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_etrade__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(5.189 6.054)',
          d: 'M0 0h21.622v19.892H0z',
        }),
      ),
    ),
  );
});
etradeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var etrade = {
  category: 'brand',
  colorable: false,
  name: 'etrade',
  svg: etradeSvg,
};
